import {ProductApi} from '@/api/product';

const SizeChartApi = {
  getSizeChartData: async (productId) => {
    if (!productId) return;
    try {
      const sizeChartData = await ProductApi.fetchProductSizingData(productId);
      return sizeChartData;
    } catch (error) {
      throw Error(`Failed to fetch size chart data for product ${productId}`);
    }
  },
};

export default SizeChartApi;
